import {functions} from "../../firestore";

let offset;

export function localToServerDate(localTimeStamp = Date.now()){
    return getServerOffset()
        .then(offset => {
            new Date(localTimeStamp - offset)
        })
}

export function getServerOffset() {
    if(offset){
        return new Promise((resolve, reject) => {
            resolve()
        }).then(() => offset)
    } else {
        return functions.httpsCallable('getServerTimestamp')({})
            .then(result => {
                const serverTimeStamp = result.data;
                offset = Date.now() - serverTimeStamp;
                return offset
            })
    }
}
